<template>
  <div class="table-search">
    <div
      class="table-search-item"
      v-for="searchItem in searchList"
      :key="searchItem.prop"
    >
      <component
        :is="'search-' + searchItem.type"
        :propKey="searchItem.prop"
        :items="searchItem.items"
        v-model="searchForm[searchItem.prop]"
        @search="search"
        :attrs="searchItem.attrs"
        @keyup.enter.native="search"
      />
    </div>
    <div class="table-search-item">
      <el-button
        @click="search"
        style="height: 100%"
        type="primary"
        :disabled="disabled"
      >
        查询
      </el-button>
    </div>
    <div class="table-search-item">
      <el-button
        @click="clear"
        style="height: 100%"
        :disabled="disabled"
      >
        清空
      </el-button>
    </div>
  </div>
</template>

<script>
import SearchSelect from "@/components/prod/center/components/SearchSelect.vue";
import SearchInput from "@/components/prod/center/components/SearchInput.vue";
import SearchCascader from '@/components/prod/center/components/searchCascader.vue'
import SearchDate from "@/components/prod/center/components/searchDate.vue";
import { PLATFORM_OPTIONS } from "@/dictionary/platforms.js"
import { getAllCatData } from "@/servers/supplier/index.js"
import { cloneDeep } from "lodash";

export default {
  components: {
    SearchSelect,
    SearchInput,
    SearchCascader,
    SearchDate,
  },
  props: {
    newPutTime: Number,
    list: Array,
    supplierCompanyId: [Number, String]
  },
  data() {
    return {
      searchForm: {
        supplierCompanyId: "",
        outerIds: "",
        skuOuterIds: "",
        title: "",
        updateTime: [],
        sellerCids: '',
        platformDataType:1,
      },
      PLATFORM_OPTIONS,
      catList: [],
    };
  },
  computed: {
    query() {
      let _query = {};
      for (const key in this.searchForm) {
        if (this.searchForm[key] !== "") {
          _query[key] = this.searchForm[key];
        }
      }
      if(Array.isArray(_query.sellerCids)){
        _query.sellerCids = _query.sellerCids.map(item=>{
          return item[item.length-1]
        })
      }
      if(_query.platformDataType === 1){
        // 【包含全部】+【已完善平台资料】
        _query.sourceAnd = _query.sources
        delete _query.sources
      }
      delete _query.platformDataType
      
      return _query;
    },
    disabled() {
      let result = (!this.list || this.list.length === 0)
        && (this.searchForm.supplierCompanyId === '')
        && (this.searchForm.outerIds === '')
        && (this.searchForm.skuOuterIds === '')
        && (this.searchForm.title === '')
        && (this.searchForm.sellerCids === '')
        && (!this.searchForm.updateTime.length);
      return result;
    },
    searchList() {
      return [
        {prop: "sellerCids", type: 'cascader', attrs:{placeholder: '商品分类', props: { checkStrictly: true }}, items: this.catList },
        {prop: "platformDataType", type: 'select', attrs:{placeholder: '筛选类型',clearable:false},isSearch:false, items: [
          {label: '包含全部', value: 1 },
          {label: '包含任一', value: 2 }
        ]},
        {
          prop: "sources", 
          type: 'select', 
          attrs:{
            placeholder: '已完善资料的平台',
            style: 'width: 200px;',
            multiple:true,
          }, 
          items: PLATFORM_OPTIONS
        },
        {
          prop: "updateTime", 
          type: 'date',
          attrs: {
            startPlaceholder: "上新开始日期",
            endPlaceholder: "上新结束日期",
            rangeSeparator: '至',
            // type: 'daterange',
            pickerOptions: {
              disabledDate: (date) => {
                let result = date.getTime() >= new Date().valueOf();
                if (!this.newPutTime) {
                  return result;
                }
                return (date.getTime() >= new Date().valueOf()) || (date.getTime() < (new Date().valueOf() - 86400000 * this.newPutTime));
              }
            },
          },
        },
        {
          prop: "outerIds",
          type: "input",
          attrs: {
            placeholder: "多个款式编码，以英文逗号分割",
            label: "款式编码",
            isDialog: true,
          },
        },
        {
          prop: "skuOuterIds",
          type: "input",
          attrs: {
            placeholder: "多个商品编码，以英文逗号分割",
            label: "商品编码",
            isDialog: true,
          },
        },
        {
          prop: "title",
          type: "input",
          attrs: {
            placeholder: "商品名称",
          },
        },
        {
          prop: "distributorState", 
          type: 'select', 
          attrs:{
            placeholder: '全部商品',
            style: 'width: 200px;',
            clearable: true
          }, 
          items: [{label:'未加入分销', value: 0},{label:'已加入分销', value: 1}]
        },
      ];
    },
  },
  watch: {
    supplierCompanyId: {
      handler (id) {
        id && this.getCatList()
      },
      immediate: true
    },
    
  },
  methods: {
    method_getSearchForm() {
      let result = cloneDeep(this.query);
      if (result.updateTime.length) {
        result.updateTimeBegin = result.updateTime[0];
        result.updateTimeEnd = result.updateTime[1];
      }
      delete result.updateTime;
      return result;
    },
    search() {
      this.$emit("search", this.query);
    },
    async getCatList() {
      const params = {
          // getData: true,
          // showHide: true,
          // userId: -1,
          companyId: this.supplierCompanyId
      }
      const { catList } = await getAllCatData(params, { isNeedLoading: false });
      this.transeCategory(catList);
      this.catList = catList;
    },
    transeCategory(options){
      if(Array.isArray(options)){
        options.forEach(item=>{
          item.value = item.cid;
          item.label = item.name;
          if (Array.isArray(item.children) && item.children.length) {
            this.transeCategory(item.children);
          } else {
            delete item.children
          }
        })
      }
    },
    clear() {
      this.searchForm = {
        platform: "",
        outerIds: "",
        skuOuterIds: "",
        title: "",
        updateTime: [],
        sellerCids: '',
        platformDataType:1
      };
      this.search();
    },
  },
  created() {
  },
};
</script>

<style lang="scss" scoped>
.table-search {
  display: flex;
  flex-wrap: wrap;

  &-item {
    margin-right: 8px;
    margin-bottom: 8px;
  }
}
</style>
